import { FormControl, FormGroup } from '@angular/forms';
import { AnvandareOrganisation } from 'src/app/auth/services/auth.model';

export const FLAT_ROLES = ['SR15', 'SR16', 'SR25', 'SR26', 'SR21', 'SR22', 'SR20'] as const;
export const INTERN_ROLES = ['SR20', 'SR21', 'SR15', 'SR16'] as const;
export const EXTERN_ROLES = ['SR22', 'SR25', 'SR26'] as const;

export enum Role {
  Systemadministrator = 'SR21',
  BehorighetsadministratorExtern = 'SR22',
  BasanvandareIntern = 'SR15',
  SuperanvandareIntern = 'SR16',
  BasanvandareExtern = 'SR25',
  SuperanvandareExtern = 'SR26',
  BehörighetsadministratörIntern = 'SR20',
}

export const RoleLabels: { [key in Role]: string } = {
  [Role.Systemadministrator]: 'Systemadministratör',
  [Role.BehorighetsadministratorExtern]: 'Extern Behörighetsadministratör',
  [Role.BasanvandareIntern]: 'Intern Basanvändare',
  [Role.SuperanvandareIntern]: 'Intern Superanvändare',
  [Role.BasanvandareExtern]: 'Extern Basanvändare',
  [Role.SuperanvandareExtern]: 'Extern Superanvändare',
  [Role.BehörighetsadministratörIntern]: 'Intern Behörighetsadministratör',

};

export interface AnvandareDTO {
  id: string;
  anvandarnamn: string;
  personnummer: string;
  anvandartyp: string;
  efternamn: string;
  epost: string;
  fornamn: string;
  organisation: string;
  organisationId: string;
  titel: string;
  status: string;
  telefon: string;
  skapad: string;
  roller: string[];
  anvandareOrganisationer: AnvandareOrganisation[];
  anvandarRoller: AnvandarRoll[]
  theChosenOrgId: string;
}

export interface UserOrganisationsDTO {
  organisationId: string;
  organisation: string;
  anvandareOrganisationer: AnvandareOrganisation[];
}
export interface AnvandareFormFields extends Omit<AnvandareDTO, 'roller'> {
  roller: FormGroup;
}

export type AnvandareFormRoll = FormGroup<{ roll: FormControl<string | null> }>;

export interface OrganisationDTO {
  id: string;
  labKod: string;
  namn: string;
  label?: string;
}

export interface AnvandarRoll {
  organisationId: string;
  roll: string;
}
